<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Instructions</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <button
            type="button" v-if="pagepermission.insertable"
            class="btn btn-primary btn-with-addon"
            @click="showFormModal"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-plus-circle" />
            </span>
            Exam Instruction
          </button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <exam-instructions-table :rolesetting="pagepermission" :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>

    <exam-instruction-form @saved="handleSaved"/>
  </div>
</template>

<script>
import ExamInstructionsTable from '@/components/online-exam/instruction/Table/index'
import ExamInstructionForm from '@/components/online-exam/instruction/Forms/index'

export default {
  components: {
    ExamInstructionsTable,
    ExamInstructionForm,
  }, // oe-instruction
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('oe-instruction', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getExamInstructions()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    showFormModal: function() {
      this.$eventBus.$emit('openExamInstructionFormModal')
    },
    getExamInstructions: function() {
      this.loading = true
      this.$http.get('/api/online-exam/instruction/all', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleSaved: function() {
      this.getExamInstructions()
    },
    handleUpdateTable: function() {
      this.getExamInstructions()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getExamInstructions()
    },
    onChange(current) {
      this.current = current
      this.getExamInstructions()
    },
  },
}
</script>
<style> .error { padding: 25px; } </style>
